export const getStyles = () => {
  const styles = window.getComputedStyle(document.body);

  return {
    lightBlue: styles.getPropertyValue("--color-light-blue"),
    middleBlue: styles.getPropertyValue("--color-middle-blue"),
    lightOrange: styles.getPropertyValue("--color-light-orange"),
    middleOrange: styles.getPropertyValue("--color-middle-orange"),
    lightRed: styles.getPropertyValue("--color-light-red"),
    middleRed: styles.getPropertyValue("--color-middle-red"),
    darkRed: styles.getPropertyValue("--color-dark-red"),
    lightPurple: styles.getPropertyValue("--color-light-purple"),
    middlePurple: styles.getPropertyValue("--color-middle-purple"),
    darkPurple: styles.getPropertyValue("--color-dark-purple"),
    lightGray: styles.getPropertyValue("--color-light-gray"),
    middleGray: styles.getPropertyValue("--color-middle-gray"),
    darkestGray: styles.getPropertyValue("--color-darkest-gray"),
    lightGreen: styles.getPropertyValue("--color-light-green"),
    middleGreen: styles.getPropertyValue("--color-middle-green"),
    middleBlack: styles.getPropertyValue("--color-middle-black"),
  };
};
